import { makeStyles } from "@mui/styles"

export const useDynamicStyles = makeStyles(({ withPalette }) => ({
  rail: ({ color }) => ({
    backgroundColor: color ? withPalette(color) : "#cfcfcf",
    borderRadius: "inherit",
    display: "block",
    height: "inherit",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "100%",

    "@media print": {
      backgroundColor: `${color ? withPalette(color) : "#cfcfcf"} !important`,
    },
  }),

  root: ({ width }) => ({
    boxSizing: "content-box",
    color: withPalette("primary"),
    cursor: "pointer",
    display: "inline-block",
    height: "8px",
    padding: "4px 0",
    position: "relative",
    width: width || "100%",

    "@media print": {
      color: `${withPalette("primary")} !important`,
    },
  }),

  thumb: ({ thumbColor }) => ({
    alignItems: "center",
    backgroundColor: "currentColor" || thumbColor,
    borderRadius: "50%",
    boxSizing: "border-box",
    display: "flex",
    height: "16px",
    justifyContent: "center",
    outline: 0,
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "16px",

    "@media print": {
      backgroundColor: thumbColor ? `${withPalette(thumbColor)} !important` : "currentColor",
    },
  }),
}))

export const useLabelOverrides = makeStyles(({ typography }) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    marginBottom: 0,
    width: "100%",
  },

  left: {
    fontSize: typography.pxToRem(12),
    verticalAlign: "top",
  },

  right: {
    fontSize: typography.pxToRem(18),
    fontWeight: "bold",
  },

  "@media print": {
    left: {
      fontSize: typography.pxToRem(10),
    },
    right: {
      fontSize: typography.pxToRem(14),
    },
  },
}))
